function isTypedArray(x) {
    return (x instanceof Uint8Array ||
        x instanceof Uint8ClampedArray ||
        x instanceof Uint16Array ||
        x instanceof Uint32Array ||
        x instanceof BigUint64Array ||
        x instanceof Int8Array ||
        x instanceof Int16Array ||
        x instanceof Int32Array ||
        x instanceof BigInt64Array ||
        x instanceof Float32Array ||
        x instanceof Float64Array);
}

export { isTypedArray };
